import {NgModule} from "@angular/core";

import {FirmSelectorComponent} from "./firm-selector/firm-selector.component";
import {CommonModule} from "@angular/common";
import {BsDropdownModule} from "ngx-bootstrap";
import { FirmService } from "./firm.service";

@NgModule({
  imports: [
    CommonModule,
    BsDropdownModule,
  ],
  declarations:[
    FirmSelectorComponent
  ],
  exports: [FirmSelectorComponent],
  providers: [FirmService]

})
export class FirmModule{}
